module.exports = __webpack_public_path__ + "img/apple-icon-152x152.5b71792f.png";